import "../pages/CheckIn.css";
import { React, useState, useEffect, useRef, Component ,useImperativeHandle, forwardRef} from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useSnackbar } from "notistack";
import { apiMain } from "../../App";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Messages } from "../data/Messages";
import {  Snackbar,Alert} from "@mui/material";
const columns = [
    // { field: 'Id', headerName: 'ID', width: 90 },
    { field: 'value', 
    headerName: 'Id', 
    width: 15 ,
    fontSize:18,
        fontWeight:'bold',},
    {
        field: 'label',
        headerName: 'Agency Name',
        width: 370,
        editable: true,
        fontSize:20,
        fontWeight:'bold',
    },
    {
        field: 'prese_UrlFile',
        headerName: 'Icon File',
        width: 70,
        editable: true,
    },

];
const paginationModel = { page: 0, pageSize: 5 };
const Presents=forwardRef((props,ref)=> {
    const [Prese_Name, setPrese_Name] = useState('');
    const [Prese_NameFlag, setPrese_NameFlag] = useState(true);
    const [Prese_Id, setPrese_Id] = useState('');
    const [Data, setData] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [dialogError, setDialogError] = useState({});
    const [dialogLoading, setDialogLoading] = useState(false);
    const [prese_UrlFile, setprese_UrlFile] = useState(null);
    const [error, setError] = useState(false);
    const [alertType , setalertType]=useState(0);
    const [txtMessage , settxtMessage]=useState("");
      // 👇 expose کردن توابع به parent
  useImperativeHandle(ref, () => ({
    add: sendAdd,
    edit: ActiveEdit,
    del: sendDelete,
    new: onNewAgency,
  }));
    const onChangeHandler = event => {
                //console.log(URL.createObjectURL(event.target.files[0]))
        setprese_UrlFile(event.target.files[0])
          }
    const ODD_OPACITY = 0.2;
    useEffect(() => {
        setAddflag(props.permission[4].Per_Add)
        setEditFlag(props.permission[4].Per_Edit)
        setDelFlag(props.permission[4].Per_Del)
        getData();
    }, [])
    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.row}.even`]: {
            backgroundColor: theme.palette.grey[200],
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&.Mui-selected': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY + theme.palette.action.selectedOpacity,
                ),
                '&:hover': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY +
                        theme.palette.action.selectedOpacity +
                        theme.palette.action.hoverOpacity,
                    ),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: alpha(
                            theme.palette.primary.main,
                            ODD_OPACITY + theme.palette.action.selectedOpacity,
                        ),
                    },
                },
            },
        },
    }));

    const [Addflag,setAddflag]=useState(true);
    const [EditFlag,setEditFlag]=useState(false);
    const [DelFlag,setDelFlag]=useState(false);
    const [NewFlag,setNewFlag]=useState(true);
    const getData = async () => {
        // let uparams = new URLSearchParams();
        // uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
        let res = await GetDataPromise(`${apiMain}/api/v1/presents`, true);
        let parsed = JSON.parse(res);
        if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
            let newData = parsed.data;
            setData(newData)

        }
    }
    const sendDelete = async (e) => {
        let formdata = new FormData();
          formdata.append("Prese_Id", Prese_Id);
         let response;
        //  setDialogLoading(true);
        if(Prese_Id > 0){
              response = await PostDataPromise(apiMain + "/api/v1/presents/delete", formdata);
         } 
         setDialogLoading(false);
        let parsed = JSON.parse(response);
        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
            // okay
            enqueueSnackbar(Messages.success, { variant: 'success' });
            setalertType(1)
            settxtMessage("Data deleted successfully.")
            setError(true);
              // props.save()
        } else {
            if(parsed.data && typeof parsed.data.message === "string"){
                enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
            }
            setDialogError((parsed.data) ? parsed.data.message : {})
        }
     //   setUpdateCount((prev) => prev + 1)
        getData();
        cleardata();
      }
  const cleardata=()=>{
    setPrese_Id(0)
    setPrese_Name('')
  }

    const sendAdd = async (e) => {
        let formdata = new FormData();
        formdata.append("Prese_Id", Prese_Id);
        formdata.append("Prese_Name", Prese_Name);
        formdata.append("prese_UrlFile", prese_UrlFile);
        let response;
                console.log("Prese_Id", formdata.get('Prese_Id'));
            console.log("Prese_Name", formdata.get('Prese_Name'));
            console.log("prese_UrlFile", formdata.get('prese_UrlFile'));
            response = await PostDataPromise(apiMain + "/api/v1/presents/insert", formdata);
            let parsed = JSON.parse(response);
            setalertType(1)
            settxtMessage("Information saved.")
            setError(true);
      
         getData();
         cleardata();
  }
  const ActiveEdit=()=>{
        setPrese_NameFlag(false)   
        props.OnchangeAgencySave(true)
  }
    const sendUpdate=async () =>{
     //   let uparams = new URLSearchParams();
        let formdata = new FormData();
        formdata.append("Prese_Id", Prese_Id);
        formdata.append("Prese_Name", Prese_Name);
        formdata.append("prese_UrlFile", prese_UrlFile);
        let response;
    
        
        // if (Prese_Id>0)
        // {

            response = await PostDataPromise(apiMain + "/api/v1/presents/update", formdata);
           let parsed = JSON.parse(response);
           setalertType(1)
           settxtMessage("Information saved.")
           setError(true);
        // }
        // else{
        //     console.log("Prese_Id", formdata.get('Prese_Id'));
        //     console.log("Prese_Name", formdata.get('Prese_Name'));
        //     console.log("prese_UrlFile", formdata.get('prese_UrlFile'));
        //     response = await PostDataPromise(apiMain + "/api/v1/presents/insert", formdata);
        //     let parsed = JSON.parse(response);
        //     console.log(parsed.status)
        //  }
         getData();
         cleardata();
    }
    const handleRowClick = (params) => {
        localStorage.setItem('Prese_Id', params.row.Prese_Id)
        setPrese_Id(params.row.value)
        setPrese_Name(params.row.label)
        setprese_UrlFile(params.row.prese_UrlFile)
        setAddflag(false);
      props.OnchangeAgencyEdit(true)
    //   props.OnchangeAgencySave(true)

    };
    const onNewAgency =()=>{
        setPrese_NameFlag(false)
        setPrese_Id(0)
        setPrese_Name('')
        props.OnchangeAgencySave(true)
    }
    return (
        <div  >
            <Box className="CheckIn" style={{ textAlign: 'left',marginLeft:'10px',marginTop:'15px', width: '700px', height: '60px' }}
                component="form"
                sx={{ '& > :not(style)': { m: 1 } }}
                noValidate
                autoComplete="off"
            >
                {/* <div style={{ textAlign: 'left',   float: 'left' }}>
                    <input
                        type="text"
                        id="Prese_Id"
                        disabled={true}
                        value={Prese_Id}
                        onChange={(e) =>
                            setPrese_Id(e.target.value)
                        }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'60px'}}
                    />
                </div> */}
           
                <div style={{ position: 'flex',marginLeft:'20px', float: 'left', marginTop: '0px', lineHeight: '.1' }}>
                <label for="" style={{marginLeft:'0px'}}> Agency Name* </label> 
                    <input
                        type="text"
                        id="Prese_Name"
                        disabled={Prese_NameFlag}
                        value={Prese_Name}
                        onChange={(e) =>setPrese_Name(e.target.value) }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'230px'}}
                    />
                           <label for="" style={{marginLeft:'10px'}}> Icon File </label>
                    <input type="file" name="file" onChange={onChangeHandler} style={{ marginLeft: '0px' }} />
                </div>
            {/* <div class style={{ float: 'left' }}> */}
     
                {/* <Button sx={{ backgroundColor: "#EDD682", color: "black", width: "170px", marginLeft: '80px', cursor: 'pointer', ":hover": { backgroundColor: "#EDD682", color: "#000000" } }}
                    type="submit"
                    value="Submit"
                    onClick={()=>sendUpdate()}
                >
                    confirm
                </Button>
                <Button sx={{ backgroundColor: "#2C2C2C", color: '#ffffff', width: "170px", marginLeft: '15px', transition: '0.7s', ':hover': { backgroundColor: "#EDD682", color: "#000000" } }}
                    type="submit"
                    value="Submit"
                  onClick={() => onNewAgency()}

                >
                    New
                </Button> */}
                </Box>
            {/* </div> */}
            <Box className="CheckIn" style={{ textAlign: 'left', width: '700px',height:'200px', marginLeft: '10px' ,marginTop:'0px'}}
                component="form"
                sx={{ '& > :not(style)': { m: 1 } }}
                noValidate
                autoComplete="off"
            >

                <div style={{ textAlign: 'left', marginTop: '5px', lineHeight: '.1' }}>
                    <Paper sx={{ height: '200px', width: '100%' }}>
                        <StripedDataGrid onRowClick={handleRowClick}
                            rows={Data}
                            columns={columns}
                            getRowId={() => crypto.randomUUID()}
                            // initialState={{ pagination: { paginationModel } }}
                            // pageSizeOptions={[5, 10]}
                            //checkboxSelection
                            sx={{ border: 0, fontFamily: 'Roboto', fontWeight: 'normal', fontSize: '12px' }}
                            // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                            }
                        />
                    </Paper>
                </div>
            </Box>


              <Snackbar
              open={error}
              autoHideDuration={6000}
              onClose={() => setError(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
      
      
      
             <Alert onClose={() => setError(false)}   variant="filled" severity={alertType ===0 ? 'error' : 'info'}>
             {txtMessage}
              </Alert>
            </Snackbar>
      
          </div>
    )
      })
          export default Presents;